import crmService from '@/services/crm_service'

const state = {
  activities: { data: [], included: [] }
}

const mutations = {
  'SET_ACTIVITIES' (state, activities) {
    state.activities = activities
  },
  'SET_ACTIVITY' (state, activity) {
    const existing = state.activities.data.find(obj => obj.id === activity.id)
    if (!existing) state.activities.data.push(activity)
    else Object.assign(existing, activity)
  }
}

const actions = {
  getActivities ({ commit }, { ownerId, curDate }) {
    crmService.getActivities(curDate, ownerId, activities => commit('SET_ACTIVITIES', activities))
  },
  getActivity ({ commit }, id) {
    crmService.getActivity(id, activity => commit('SET_ACTIVITY', activity))
  }
}

const getters = {
  activities: state => {
    return state.activities
  },
  activity: (state) => (id) => {
    return state.activities.data.find(obj => obj.id === id) || { attributes: {} }
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
